import React, { CSSProperties, useMemo } from "react";
import {
  chunk,
  concat,
  get,
  isEmpty,
  map,
  orderBy,
  reduce,
  sumBy,
} from "lodash";
import Table from "./Table";
import { useSelector } from "react-redux";
import { selectStatGroupByPlayerByRound } from "../store/betStatsSlice";
import { getPlayerMappingByPlayerId } from "../store/playerSlice";
import { RankElement } from "./FirstRound";

function Top10() {
  const playersMapping = useSelector(getPlayerMappingByPlayerId);
  const statByPlayer = useSelector((state: any) =>
    selectStatGroupByPlayerByRound(state, "final")
  );

  const cols = useMemo(() => {
    return [
      {
        key: "name",
        col: 5,
        format: (val: string | number) => (
          <div className="d-flex gap-2 align-items-center">
            {/* <img
              alt="profile"
              src="/assets/profile-user.svg"
              width={32}
              height={32}
              loading="eager"
            /> */}
            <div>{val}</div>
          </div>
        ),
      },
      // {
      //   key: "shoe",
      //   col: 1,
      //   className: "justify-content-center",
      // },
      // {
      //   key: "point",
      //   col: 2,
      //   className: "justify-content-end",
      // },
      {
        key: "chip",
        col: 6,
        className: "justify-content-end px-3",
        format: (val: string | number) =>
          val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
    ];
  }, []);

  const emptyPlayers = useMemo(() => {
    return map(Array(25), (_, index) => ({
      id: `empty-${index}`,
      name: "",
      chip: 0,
      winStack: 0,
    }));
  }, []);

  const groups = useMemo(() => {
    const players = reduce(
      playersMapping,
      (result, player, index) => {
        if (player.id && player.finalRoundGroupId) {
          const stat = get(statByPlayer, player.id, []);
          result.push({
            id: player?.id,
            name: player?.nickname ?? "",
            chip: player?.id
              ? isEmpty(stat)
                ? 500000
                : sumBy(stat, "totalBalance")
              : 0,
            winStack: player?.id ? sumBy(stat, "maxWinStackTimes") : 0,
          });
        }
        return result;
      },
      [] as Array<{ id: string; name: string; chip: number; winStack: number }>
    );

    return concat(
      orderBy(players, ["chip", "winStack", "name"], ["desc", "desc", "desc"]),
      emptyPlayers
    ).slice(0, 25);
  }, [emptyPlayers, playersMapping, statByPlayer]);
  return (
    <div className="position-relative">
      <div
        className="position-relative align-items-end mt-4 mx-auto animate-order"
        style={{ height: "190px", width: "90%" }}
      >
        {map(groups?.slice(0, 5), (player, index) => {
          return (
            <RankElement
              key={get(player, "id", `no${index + 1}`)}
              rank={index + 1}
              player={player}
            />
          );
        })}
      </div>
      <div id="first-round-table" className="mt-3">
        <div
          className={`row row-cols-2 g-4 mt-0 border-between`}
          style={
            {
              fontSize: "1.5rem",
              "--text-gradient":
                "linear-gradient(180deg, #FFFFFF 50%, #9C9C9C 100%)",
            } as CSSProperties
          }
        >
          {map(chunk(groups?.slice(5, 25), 10), (group, index) => (
            <div key={index} className="col mt-0">
              <Table
                // header={group.name}
                items={group}
                cols={cols}
                startRank={index * 10 + 6}
                colorFirst
                // titles={titles}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Top10;
